<template>
	<modal-tipo-documento
		ref="modalTipoDocumento"
		:exibir="exibir"
		@confirmar="confirmar"
		@fechar-modal="fecharModal"
	></modal-tipo-documento>
</template>

<script>
import { actionTypes, mutationTypes } from '@/core/constants'
import ModalTipoDocumento from '@/views/pages/configuracao/tipo-documento/modal-tipo-documento/ModalTipoDocumento.vue'

export default {
	name: 'novo-tipo-documento',
	components: { ModalTipoDocumento },
	props: {
		exibir: {
			type: Boolean,
		},
	},
	methods: {
		async confirmar(data) {
			await this.$store.dispatch(actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.CRIAR_TIPO_DOCUMENTO, data)

			this.$refs.modalTipoDocumento.limparTipoDocumento()
			this.mostrarNotificacaoSucessoDefault()
			this.recarregarListagemExterna()
			this.fecharModal()
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
		recarregarListagemExterna() {
			this.$store.commit(mutationTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.RESET_FILTRO_LISTAGEM)
			this.$store.commit(mutationTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.RESET_PAGINACAO_LISTAGEM)
			this.$emit('recarregar-listagem-tipo-documento')
		},
	},
}
</script>

<style scoped lang="stylus"></style>
